import { Container, Sprite, Texture } from '../../../odie';

import { BaseBlockProps } from '../../defs/block';
import { config } from '../../defs/config';

export class FitWidthBlockSprite extends Sprite {
  constructor(textureId: string, props?: BaseBlockProps) {
    super(Texture.from(textureId));
    this.anchorX = this.anchorY = 0.5;
    this.scaleX = this.scaleY = getBlockViewScale(this.width, props);
  }
}

export function getBlockViewScale(
  currentWidth: number,
  props?: BaseBlockProps,
) {
  return ((props?.width || 1) * config.tile.size) / currentWidth;
}
